import * as React from "react";
import * as showdown from "showdown";
import { UserMessagePage } from "./userMessageTypes";
import TextField from "@material-ui/core/TextField";
import Page from "./UserMessagePageContainer";
import Button from "@material-ui/core/Button";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import PosConsoleApi from "app/utils/PosConsoleApi";
import handleMutationError from "app/utils/handleMutationError";
import Dialog from "@material-ui/core/Dialog";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
} from "@material-ui/core";

type Props = {
  page: UserMessagePage;
  userMessageId: number;
  close: Function;
  editUserMessagePage?: any;
  data?: any;
  deeplinkUrls?: any;
};

type State = {
  body: string;
  deeplink_action_path: string;
  external_action: string;
  deeplink_select_value: DeeplinkOption | null;
  deeplink_uid: string;
  image: string;
  image_identifier: string;
  uploading: boolean;
};

type DeeplinkOption = {
  url: string;
  require_uid: boolean;
};

class EditPageModal extends React.Component<Props, State> {
  showdownConverter: showdown.Converter;

  constructor(props: any) {
    super(props);
    this.state = {
      body: props.page.body,
      deeplink_action_path: props.page.deeplink_action_path,
      external_action: props.page.external_action,
      deeplink_select_value: props.page.deeplink_action,
      deeplink_uid: props.page.deeplink_action_uid,
      image: props.page.image,
      image_identifier: props.page.image_identifier,
      uploading: false,
    };
    this.showdownConverter = new showdown.Converter({
      strikethrough: true,
      emoji: true,
      underline: true,
      smoothLivePreview: true,
    });
  }

  onDeeplinkSelect = (value: string) => {
    const deeplinkObject: DeeplinkOption =
      value === ""
        ? { url: "", require_uid: false }
        : this.getDeepLinkOptions().find((d) => d.url === value);
    this.setState({
      deeplink_select_value: deeplinkObject,
      deeplink_action_path: deeplinkObject.url,
      deeplink_uid: "",
    });
  };

  onSave = (): void => {
    this.props
      .editUserMessagePage({
        variables: {
          user_message_id: this.props.userMessageId,
          id: this.props.page.id,
          body: this.state.body,
          image: this.state.image_identifier,
          deeplink_action:
            this.state.deeplink_action_path + this.state.deeplink_uid,
          external_action: this.state.external_action,
        },
      })
      .then(() => {
        this.props.close({ refetchData: true });
      })
      .catch((error) => {
        handleMutationError(error);
      });
  };

  uploadFile = (event: any) => {
    if (!event.target.files[0]) {
      return;
    }
    this.setState({ uploading: true });
    const params: any = {
      user_message_id: this.props.userMessageId,
      image: event.target.files[0],
    };
    if (this.props.page.id != null) {
      params.page_id = this.props.page.id;
    }
    PosConsoleApi.postMultipart("user_messages/page_image", params)
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          uploading: false,
          image: response.url,
          image_identifier: response.identifier,
        });
      })
      .catch((error) => {
        this.setState({
          uploading: false,
        });
        alert(error);
      });
  };

  getDeepLinkOptions(): Array<DeeplinkOption> {
    return (
      (this.props.deeplinkUrls &&
        this.props.deeplinkUrls.user_message_deeplink_urls) ||
      []
    );
  }

  renderBodyForm = () => {
    const showUidEntry: boolean =
      (this.state.deeplink_select_value &&
        this.state.deeplink_select_value.require_uid) ||
      !!this.state.deeplink_uid;
    return (
      <section
        style={{
          display: "flex",
          flex: "0 0 50%",
          overflowX: "hidden",
          overflowY: "hidden",
          paddingRight: "24px",
          boxSizing: "border-box",
          flexDirection: "column",
        }}
      >
        <div style={{ display: "flex", alignItems: "Center" }}>
          <div style={{ flex: "0 0 auto" }}>
            <input
              accept="image/*"
              style={{ display: "none" }}
              id="page-image-upload"
              type="file"
              onChange={(event) => this.uploadFile(event)}
            />
            <label htmlFor="page-image-upload">
              <Button
                color="secondary"
                variant="contained"
                id="page-image-upload"
                component="span"
                disabled={this.state.uploading}
              >
                {this.state.uploading ? "Uploading..." : "Upload"}
              </Button>
            </label>
          </div>
        </div>
        <TextField
          style={{ flex: "1 0 auto" }}
          select={true}
          margin="none"
          fullWidth={true}
          value={this.state.deeplink_action_path || ""}
          onChange={(event) => this.onDeeplinkSelect(event.target.value)}
          label="Deep link (Optional)"
        >
          <MenuItem key={0} value="">
            None
          </MenuItem>
          {this.getDeepLinkOptions().map((option, i) => (
            <MenuItem key={i + 1} value={option.url}>
              {option.url}
            </MenuItem>
          ))}
        </TextField>
        {showUidEntry ? (
          <TextField
            style={{ flex: "1 0 auto" }}
            type={"text"}
            label="UID"
            value={this.state.deeplink_uid || ""}
            onChange={(event) =>
              this.setState({ deeplink_uid: event.target.value })
            }
          />
        ) : null}
        <TextField
          style={{ flex: "1 0 auto" }}
          label="External link (Optional)"
          name="external_action"
          fullWidth={true}
          value={this.state.external_action || ""}
          onChange={(event) =>
            this.setState({ external_action: event.target.value })
          }
        />
        <TextField
          style={{ flex: "1 0 auto", overflowY: "scroll", maxHeight: "150px" }}
          multiline={true}
          label="Body"
          name="body"
          fullWidth={true}
          value={this.state.body}
          onChange={(event) => this.setState({ body: event.target.value })}
        />
        {this.renderCheatSheetLinks()}
      </section>
    );
  };

  renderBodyLivePreview = () => {
    const builtPage: UserMessagePage = {
      id: this.props.page.id,
      body: this.state.body,
      image: this.state.image,
    };
    return (
      <section
        style={{
          flex: "0 0 50%",
          overflowX: "hidden",
          overflowY: "scroll",
          paddingLeft: "24px",
          boxSizing: "border-box",
        }}
      >
        <Page page={builtPage} livePreview={true} safeMode={false} />
      </section>
    );
  };

  renderCheatSheetLinks = () => {
    return (
      <div style={{ display: "flex", marginTop: "5px" }}>
        <a
          style={{ marginLeft: "5px" }}
          className="blueLink small"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.markdownguide.org/cheat-sheet/"
        >
          Markdown?
        </a>
        <a
          style={{ marginLeft: "5px" }}
          className="blueLink small"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.webfx.com/tools/emoji-cheat-sheet/"
        >
          Emoji?
        </a>
      </div>
    );
  };

  render() {
    return (
      <Dialog
        open={this.props.page != null}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth={"md"}
      >
        <DialogTitle id="form-dialog-title">Edit Page</DialogTitle>
        <DialogContent>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              flex: "1 0 100%",
              overflow: "hidden",
              fontFamily: "Roboto, Sans-serif",
              color: "#00000099",
            }}
          >
            {this.renderBodyForm()}
            {this.renderBodyLivePreview()}
          </div>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={() => this.props.close()}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={this.state.uploading}
            color="primary"
            onClick={this.onSave}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const editUserMessagePage = graphql<Props, any, any>(
  gql`
    mutation editUserMessagePage(
      $user_message_id: ID!
      $id: ID
      $body: String
      $image: String
      $deeplink_action: String
      $external_action: String
    ) {
      update_user_message_page(
        user_message_id: $user_message_id
        id: $id
        body: $body
        image: $image
        deeplink_action: $deeplink_action
        external_action: $external_action
      ) {
        id
      }
    }
  `,
  { name: "editUserMessagePage" }
);

const deeplinksQuery = graphql<any, Props>(
  gql`
    query deeplinkUrls {
      user_message_deeplink_urls {
        url
        require_uid
      }
    }
  `,
  { name: "deeplinkUrls" }
);

export default compose<any>(editUserMessagePage, deeplinksQuery)(EditPageModal);
